import React from "react";
import classnames from "classnames";
import styles from "./MessageModal.module.scss";
import { BaseModal, IModalProps, ModalHeader } from "..";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";

interface IMessageModalProps extends IModalProps<any> {
  title?: React.ReactNode;
  okText?: string;
  children?: React.ReactNode;
  okTestId?: string;
  hideOkButton?: boolean;
}

export const MessageModal: React.FC<IMessageModalProps> = (props) => {
  return (
    <BaseModal {...props} closeModal={props.closeModal} header={<ModalHeader closeModal={props.closeModal}>{props.title}</ModalHeader>}>
      <div className={classnames(styles.messgeBody, props.bodyClassName)}>{props.children}</div>
      {!props.hideOkButton && <ModalButtons testId={props.okTestId} submitText={props.okText} onSubmit={props.closeModal} hideCancel={true} />}
    </BaseModal>
  );
};
